import { useState } from "react";
import Header from "./Header";
import Projects from "./Projects";
import data from "./ProjectsData";

function App() {
  const [items, setItems] = useState(data);

  return (
    <div className="App">
      {/* <Header /> */}
      <Projects items={items} />
      <footer className=" flex flex-wrap  justify-center items-center relative bottom-0 max-w-full  text-center md:h-10  bg-blue-50 mt-24 ">
				Made with <a className=" mx-1 text-blue-900" href="https://reactjs.org/" rel="noreferrer" target="_blank">React.js</a> and
				<a href="https://tailwindcss.com/" className="mx-1 text-blue-900" rel="noreferrer" target="_blank">tailwind css</a> |
				connect with me 👉🏼 <a className="text-blue-900 mx-1" href="https://twitter.com/DaswantSaurabh" rel="noreferrer" target="_blank"> twitter</a> 🤝🏼 
			</footer>
      
    </div>
  );
}

export default App;
